import api, { authHeader } from "../config/api";

export const configServices = {
  getConfigServer: () => api.get(`/api/v1/config`, { headers: authHeader()}),
};
